<script>
/**
 * ****************************************************************************
 * @description     :   Main component for CUS_Client004
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
import CUS_Client004 from '@/views/move/cus_client/CUS_Client004/store';
import { NOTE_ADDRESS_1, NOTE_ADDRESS_2, regexpValidateEmail } from '@/utils/constants';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import helpers from '@/utils/helpers';
import AnsZipCode from '@/components/ansZipCode/index.vue';
import AnsPhoneFax from '@/components/ansPhoneFax/index.vue';
import AnsCheckbox from '@/components/ansCheckbox/index.vue';
import AnsButton from '@/components/ansButton/index.vue';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';

/**
 * Define component chat for show page chat
 */
var MasterSearch = {
    components: { AnsButton, AnsCheckbox, AnsPhoneFax, AnsZipCode },
    props: {
        locationCd: {
            type: [Number, String],
            default: null
        },
        personalId: {
            type: [Number, String],
            default: null
        }
    },
    template: template,
    beforeCreate() {
        if (!store.hasModule('CUS_Client004')) {
            store.registerModule('CUS_Client004', CUS_Client004);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        this.onInitScreen();
    },
    mounted() {
        // this.setHeader(this.header);
        // if (this.$route.params.customer_cd && this.$route.params.branch_cd) {
        //     this.getCustomerInfo({
        //         customer_cd: this.$route.params.customer_cd,
        //         branch_cd: this.$route.params.branch_cd
        //     });
        // } else {
        //     this.resetDataInit();
        //     this.mode = 0;
        // }
        // window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.setHeader();
        this.hideModalMessage();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'CUS_Client004',
            userId: '',
            mode: 1,
            errors: [],
            exitCustomer: true,
            count_date: '',
            showMessage: false,
            note_address1: NOTE_ADDRESS_1,
            note_address2: NOTE_ADDRESS_2
        };
    },
    watch: {
        'data.area'(val) {
            if (!val) {
                this.data.area_name = '';
            } else {
                this.data.area_name = '東日本統括部';
            }
        },
        'data.usage'(val) {
            this.showMessage = val === '2';
        },
        locationCd() {
            this.referData();
        }
    },
    computed: {
        ...mapState('app', ['S9007', 'zoom', 'user']),
        ...mapState('CUS_Client004', ['data', 'selectOptionKey', 'totalRows', 'listData', 'msgNoData', 'isSuccess', 'data_select']),
        header() {
            const data = {
                title: '発注拠点登録',
                showBack: true,
                onBack: () => {
                    this.$router.push({
                        name: 'CUS_Client003',
                        query: { clear: 1 }
                    });
                }
            };
            return data;
        },
        // canSubmit() {
        //     return !!this.data.customer_cd && this.data.branch_cd;
        // },
        disableButton() {
            if (this.errors.length > 0) {
                return true;
            }
            const phone = this.data.phone.split('-');
            // const fax = this.data.fax.split('-');
            const contactTel = this.data.contact_tel.split('-');
            let countPhone = 0;
            let countContactTel = 0;
            if (phone[0]) {
                countPhone = countPhone + phone[0].length;
            }
            if (phone[1]) {
                countPhone = countPhone + phone[1].length;
            }
            if (phone[2]) {
                countPhone = countPhone + phone[2].length;
            }
            //
            if (contactTel[0]) {
                countContactTel = countContactTel + contactTel[0].length;
            }
            if (contactTel[1]) {
                countContactTel = countContactTel + contactTel[1].length;
            }
            if (contactTel[2]) {
                countContactTel = countContactTel + contactTel[2].length;
            }
            return !(
                this.data.location_name &&
                this.data.zipcode &&
                this.data.address1 &&
                this.data.contact_email &&
                // this.data.address3 &&
                phone[0] &&
                phone[1] &&
                phone[2] &&
                (countPhone == 10 || countPhone == 11 || countPhone == 12) &&
                // fax[0] &&
                // fax[1] &&
                // fax[2] &&
                contactTel[0] &&
                contactTel[1] &&
                contactTel[2] &&
                (countContactTel == 10 || countContactTel == 11 || countContactTel == 12) &&
                this.data.order_expectation
            );
        },
        isMobile() {
            return helpers.checkIfMobile();
        }
    },
    emits: ['refer'],
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        ...mapMutations('CUS_Client004', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        ...mapActions('CUS_Client004', ['getCustomerInfo', 'getCustomerMFIL001', 'getAreaInfo', 'getOfficeInfo', 'store']),
        onInitScreen() {
            this.resetDataInit({
                mode: this.mode,
                location_cd: this.locationCd
            });
            this.errors = [];
        },
        referAddressByZipCode(address) {
            this.data.address1 = address;
        },
        renderError(id) {
            let message = '';
            if (this.errors) {
                this.errors.forEach((item) => {
                    if (item.name == id) {
                        message = item.message;
                    }
                });
            }
            return message;
        },
        referCustomer(index, string) {
            console.log(index);
            this.errors = [];
            if (string == '') {
                this.data.customer_cd = '';
                this.data.customer_name = '';
            } else {
                // this.getCustomerMFIL001({
                //     body: {
                //         // customer_cd: this.data.customer_cd
                //         customer_cd: string
                //     },
                //     callback: (response) => {
                //         if (response?.customer_name) {
                //             this.data.customer_name = response?.customer_name;
                //             this.exitCustomer = true;
                //         } else {
                //             this.exitCustomer = false;
                //             this.data.customer_name = '';
                //             this.addError({
                //                 name: 'customer_cd',
                //                 message: 'カスタムーCDが存在しません。'
                //             });
                //         }
                //     },
                //     onError: (errorMessage) => {
                //         this.data.customer_cd = '';
                //         this.data.customer_name = '';
                //         this.showHeaderError([errorMessage ?? messages.E999]);
                //     }
                // });
                this.data.customer_cd = string;
                this.data.customer_name = 'コントロールセン';
            }
        },
        referBranch(index, string) {
            console.log(index);
            this.errors = [];
            if (string == '') {
                this.data.branch_cd = '';
                this.data.branch_name = '';
            } else {
                this.data.branch_cd = string;
                this.data.branch_name = 'コントロールセン';
            }
        },
        changeArea() {
            if (this.data.area_cd == '') {
                this.data.area_name = '';
            } else {
                this.getAreaInfo({
                    body: {
                        company_cd: 1,
                        area_cd: this.data.area_cd
                    },
                    callback: (response) => {
                        if (response?.area_name) {
                            this.data.area_name = response?.area_name;
                        } else {
                            this.data.area_name = '';
                        }
                    },
                    onError: (errorMessage) => {
                        this.data.area_cd = '';
                        this.data.area_name = '';
                        this.showHeaderError([errorMessage ?? messages.E999]);
                    }
                });
            }
        },
        changeOffice() {
            if (this.data.office_cd == '') {
                this.data.office_name = '';
            } else {
                this.getOfficeInfo({
                    body: {
                        area_cd: this.data.area_cd,
                        office_cd: this.data.office_cd
                    },
                    callback: (response) => {
                        if (response?.office_name) {
                            this.data.office_name = response?.office_name;
                        } else {
                            this.data.office_name = '';
                        }
                    },
                    onError: (errorMessage) => {
                        this.data.office_cd = '';
                        this.data.office_name = '';
                        this.showHeaderError([errorMessage ?? messages.E999]);
                    }
                });
            }
        },
        countDate() {
            this.count_date = 0;
            if (this.data.date_of_payment == 1) {
                if (this.data.closing_date <= this.data.closing_date_payment) {
                    this.count_date = this.data.closing_date_payment * 5 - this.data.closing_date * 5;
                }
            } else if (this.data.date_of_payment == 2) {
                this.count_date = 30 + this.data.closing_date_payment * 5 - this.data.closing_date * 5;
            } else {
                this.count_date = 60 + this.data.closing_date_payment * 5 - this.data.closing_date * 5;
            }
        },
        scrollTop() {
            window.scrollTo(0, 0);
        },
        addError(message) {
            this.errors.push(message);
        },
        removeError(fieldName) {
            this.errors = this.errors.filter((e) => e.name !== fieldName);
        },
        submit() {
            if (!(this.data.fax.length > 11 && this.data.fax.length < 15)) {
                let error = {
                    name: 'fax',
                    message: 'FAX番号の形式が正しくありません。'
                };
                if (this.data.fax.length == 2 || this.data.fax.length == 0) {
                    this.removeError('fax');
                } else {
                    this.errors.push(error);
                }
            } else {
                this.removeError('fax');
            }
            let errorMsg = helpers.renderMsgErr(this.errors);
            if (errorMsg != '') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: errorMsg,
                    okText: MSG_BUTTON.okText
                });
            } else {
                if (!this.exitCustomer) {
                    this.scrollTop();
                    return;
                }
                this.errors = [];
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.C002,
                    content: !this.locationCd ? messages.C001 : messages.C002,
                    cancelText: 'いいえ',
                    okText: 'はい',
                    callback: (ok) => {
                        if (ok) {
                            const phone = this.data.phone.split('-');
                            const fax = this.data.fax.split('-');
                            const contact_tel = this.data.contact_tel.split('-');
                            this.store({
                                body: {
                                    ...this.data,
                                    personal_id: this.personalId,
                                    tel1: phone[0] ?? '',
                                    tel2: phone[1] ?? '',
                                    tel3: phone[2] ?? '',
                                    fax1: fax[0] ?? '',
                                    fax2: fax[1] ?? '',
                                    fax3: fax[2] ?? '',
                                    contact_tel1: contact_tel[0] ?? '',
                                    contact_tel2: contact_tel[1] ?? '',
                                    contact_tel3: contact_tel[2] ?? ''
                                },
                                callback: (response) => {
                                    console.log('response', response);
                                    this.showModalMessage({
                                        title: '報告',
                                        content: !this.locationCd ? '登録しました。' : '変更しました。',
                                        okText: 'OK'
                                    });
                                    this.referData();
                                    this.$emit('refer');
                                },
                                onErrorValidate: () => {
                                    this.addError({
                                        name: 'email',
                                        message: 'このメールアドレスは既に登録されています。'
                                    });
                                    this.scrollTop();
                                },
                                onError: (errorMessage) => {
                                    this.showHeaderError([errorMessage ?? messages.E999]);
                                }
                            });
                        }
                    }
                });
            }
        },
        getOfficeName(data) {
            this.data.office_name = data;
        },
        //referAreaSearch
        referAreaSearch(index, value) {
            console.log('index :>> ', index);
            this.data.area_cd = value;
            if (this.data.area_cd == '') {
                this.data.area_name = '';
            } else {
                this.data.area_name = '東日本統括部';
            }
        },
        getAreaName(data) {
            this.data.area_name = data;
        },
        getCustomerName(data) {
            this.data.customer_name = data;
        },
        getBranchName(data) {
            this.data.branch_name = data;
        },
        validateEmail(event) {
            const id = event.target.id;
            const string = event.target.value;
            const regexp = regexpValidateEmail;
            if (regexp.test(string) || string.trim() == '') {
                this.errors = this.errors.filter((error) => error.name !== id);
            } else {
                const existingErrorIndex = this.errors.findIndex((error) => error.name === id);
                let error = {
                    name: id,
                    message: 'メールアドレスのフォーマットが正しくありません。'
                };
                if (existingErrorIndex !== -1) {
                    this.errors.splice(existingErrorIndex, 1, error);
                } else {
                    this.errors.push(error);
                }
            }
        },
        referData() {
            if (this.locationCd) {
                this.getCustomerInfo({
                    branch_cd: this.locationCd
                });
                setTimeout(() => {
                    document.getElementById('branchName').focus();
                }, 100);
            } else {
                this.resetDataInit({
                    customer_cd: this.user.customer_cd,
                    customer_name: this.user.customer_name
                });
            }
            this.errors = [];
            setTimeout(() => {
                document.getElementById('branchName').focus();
            }, 100);
        },
        handleReferKana(autokana) {
            const id = autokana.elFurigana.id;
            const furigana = autokana.furigana;
            if (id == 'representative_first_name_kana') {
                this.data.contact_first_name_kana = furigana;
            } else if (id == 'representative_last_name_kana') {
                this.data.contact_last_name_kana = furigana;
            }
        }
    }
};
export default MasterSearch;
</script>
